<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-account"
          :title="$route.params.id ? $t('Edit Doortype') : $t('New Doortype')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem(true)"
          >
            <v-tabs v-model="tab" background-color="gray" dark right>
              <v-tab key="data">{{ $t("data") }}</v-tab>
              <v-tab key="usage">{{ $t("usage") }}</v-tab>
              <v-tabs-items v-model="tab">
                <v-tab-item key="data" class="pt-3">
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="formValues.code"
                        label="Code"
                        v-validate="'required'"
                        required
                        outlined
                        data-vv-name="code"
                        :error-messages="errors.collect('code')"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-select
                        v-model="formValues.door_type_category_id"
                        :items="typeCategories"
                        :label="$t('category')"
                        item-text="name"
                        item-value="id"
                        v-validate="'required'"
                        required
                        outlined
                        data-vv-name="door_type_category_id"
                        :disabled="
                          formValues.id && !formValues.allow_category_edit
                        "
                        :error-messages="
                          errors.collect('door_type_category_id')
                        "
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-checkbox
                        v-model="formValues.active"
                        :label="$t('active')"
                        v-validate="'required'"
                        required
                        data-vv-name="active"
                        :error-messages="errors.collect('active')"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="formValues.name"
                        label="Name"
                        v-validate="'required'"
                        required
                        outlined
                        data-vv-name="name"
                        :error-messages="errors.collect('name')"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="formValues.name_it"
                        label="Name IT"
                        v-validate=""
                        required
                        outlined
                        data-vv-name="name_it"
                        :error-messages="errors.collect('name_it')"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-textarea
                    v-model="formValues.description"
                    :label="$t('description')"
                    v-validate="'required'"
                    required
                    outlined
                    data-vv-name="description"
                    :error-messages="errors.collect('description')"
                  ></v-textarea>
                  <v-textarea
                    v-model="formValues.glass_info"
                    :label="$t('glass_info')"
                    v-validate="'required'"
                    required
                    outlined
                    data-vv-name="glass_info"
                    :error-messages="errors.collect('glass_info')"
                  ></v-textarea>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="formValues.height_min"
                        type="number"
                        :label="$t('min_frame_height') + ' [mm]'"
                        v-validate="'required'"
                        required
                        outlined
                        data-vv-name="height_min"
                        :error-messages="errors.collect('height_min')"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="formValues.height_max"
                        type="number"
                        :label="$t('max_frame_height') + ' [mm]'"
                        v-validate="'required'"
                        required
                        outlined
                        data-vv-name="height_max"
                        :error-messages="errors.collect('height_max')"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="formValues.width_min"
                        type="number"
                        :label="$t('min_frame_width') + ' [mm]'"
                        v-validate="'required'"
                        outlined
                        required
                        data-vv-name="width_min"
                        :error-messages="errors.collect('width_min')"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="formValues.width_max"
                        type="number"
                        :label="$t('max_frame_width') + ' [mm]'"
                        v-validate="'required'"
                        required
                        outlined
                        data-vv-name="width_max"
                        :error-messages="errors.collect('width_max')"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="formValues.overhang"
                        type="number"
                        :label="$t('overhang') + ' [mm]'"
                        v-validate="'required'"
                        required
                        outlined
                        data-vv-name="overhang"
                        :error-messages="errors.collect('overhang')"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="formValues.frame_width_min"
                        type="number"
                        :label="$t('frame_min_width') + ' [mm]'"
                        v-validate="'required'"
                        outlined
                        required
                        data-vv-name="frame_width_min"
                        :error-messages="errors.collect('frame_width_min')"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="formValues.frame_thickness_min"
                        type="number"
                        :label="$t('frame_min_thickness') + ' [mm]'"
                        v-validate="'required'"
                        outlined
                        required
                        data-vv-name="frame_thickness_min"
                        :error-messages="errors.collect('frame_thickness_min')"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-select
                        v-model="formValues.frames"
                        :items="frames"
                        multiple
                        :label="$t('frame')"
                        item-text="name"
                        item-value="id"
                        v-validate="'required'"
                        chips
                        required
                        outlined
                        data-vv-name="frames"
                        :error-messages="errors.collect('frames')"
                      >
                        <template v-slot:selection="data">
                          <draggable
                            :id="data.index"
                            :list="formValues.frames"
                            v-bind="dragOptions"
                            :move="move"
                            @change="change(formValues.frames, $event)"
                          >
                            <v-chip
                              draggable
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              :key="data.id"
                              close
                              @click:close="
                                remove(formValues.frames, data.index)
                              "
                              @mousedown.stop
                              @click.stop
                            >
                              {{ data.item.name }}
                            </v-chip>
                          </draggable>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col>
                      <v-select
                        v-model="formValues.wallconnections"
                        :items="wallconnections"
                        :label="$t('wallconnections')"
                        item-text="name"
                        item-value="id"
                        v-validate="'required'"
                        multiple
                        chips
                        outlined
                        required
                        data-vv-name="wallconnections"
                        :error-messages="errors.collect('wallconnections')"
                      >
                        <template v-slot:selection="data">
                          <draggable
                            :id="data.index"
                            :list="formValues.wallconnections"
                            v-bind="dragOptions"
                            :move="move"
                            @change="change(formValues.wallconnections, $event)"
                          >
                            <v-chip
                              draggable
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              :key="data.id"
                              close
                              @click:close="
                                remove(formValues.wallconnections, data.index)
                              "
                              @mousedown.stop
                              @click.stop
                            >
                              {{ data.item.name }}
                            </v-chip>
                          </draggable>
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-select
                        v-model="formValues.numberranges"
                        :items="numberranges"
                        :label="$t('numberranges')"
                        item-text="name"
                        item-value="id"
                        v-validate="'required'"
                        multiple
                        chips
                        outlined
                        required
                        data-vv-name="numberranges"
                        :error-messages="errors.collect('numberranges')"
                      >
                        <template v-slot:selection="data">
                          <draggable
                            :id="data.index"
                            :list="formValues.numberranges"
                            v-bind="dragOptions"
                            :move="move"
                            @change="change(formValues.numberranges, $event)"
                          >
                            <v-chip
                              draggable
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              :key="data.id"
                              close
                              @click:close="
                                remove(formValues.numberranges, data.index)
                              "
                              @mousedown.stop
                              @click.stop
                            >
                              {{ data.item.name }}
                            </v-chip>
                          </draggable>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col>
                      <v-select
                        v-if="hasedgespacers"
                        v-model="formValues.edgespacers"
                        :items="edgespacers"
                        :label="$t('edgespacers')"
                        item-text="name"
                        item-value="id"
                        v-validate="'required'"
                        chips
                        multiple
                        outlined
                        required
                        data-vv-name="edgespacers"
                        :error-messages="errors.collect('edgespacers')"
                      >
                        <template v-slot:selection="data">
                          <draggable
                            :id="data.index"
                            :list="formValues.edgespacers"
                            v-bind="dragOptions"
                            :move="move"
                            @change="change(formValues.edgespacers, $event)"
                          >
                            <v-chip
                              draggable
                              v-bind="data.attrs"
                              :input-value="data.selected"
                              :key="data.id"
                              close
                              @click:close="
                                remove(formValues.edgespacers, data.index)
                              "
                              @mousedown.stop
                              @click.stop
                            >
                              {{ data.item.name }}
                            </v-chip>
                          </draggable>
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="formValues.certification_authority"
                        :label="$t('certification_authority')"
                        v-validate="'required'"
                        required
                        outlined
                        data-vv-name="certification_authority"
                        :error-messages="
                          errors.collect('certification_authority')
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="formValues.certification_number"
                        :label="$t('certification_number')"
                        v-validate="'required'"
                        required
                        outlined
                        data-vv-name="certification_number"
                        :error-messages="errors.collect('certification_number')"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="formValues.certification_price"
                        type="number"
                        :label="$t('certification_price') + ' [€]'"
                        v-validate="'required'"
                        required
                        outlined
                        data-vv-name="certification_price"
                        :error-messages="errors.collect('certification_price')"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="formValues.homologation"
                        :label="$t('homologation')"
                        v-validate="'required'"
                        required
                        outlined
                        data-vv-name="homologation"
                        :error-messages="errors.collect('homologation')"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="formValues.homologation_name"
                        :label="$t('homologation_name')"
                        v-validate="'required'"
                        required
                        outlined
                        data-vv-name="homologation_name"
                        :error-messages="errors.collect('homologation_name')"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-checkbox
                    v-model="formValues.production_notification"
                    :label="$t('product_notification')"
                    v-validate=""
                    data-vv-name="production_notification"
                    :error-messages="errors.collect('production_notification')"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="formValues.require_threshold_type"
                    :label="$t('require_treshhold_type')"
                    v-validate=""
                    data-vv-name="require_threshold_type"
                    :error-messages="errors.collect('require_threshold_type')"
                  ></v-checkbox>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="formValues.weight_per_qm"
                        type="number"
                        :label="$t('weight_per_qm') + ' [kg/qm]'"
                        v-validate="'required'"
                        required
                        outlined
                        data-vv-name="weight_per_qm"
                        :error-messages="errors.collect('weight_per_qm')"
                      ></v-text-field>
                    </v-col>
                    <v-col> </v-col>
                  </v-row>

                  <v-card color="#eee" class="pa-2">
                    <v-row>
                      <v-col>
                        <h2>{{ $t("Technical data") }}</h2>
                      </v-col>
                    </v-row>
                    <v-tabs v-model="tab_tecnical" background-color="gray" dark>
                      <v-tab key="0">{{ $t("normal") }}</v-tab>
                      <v-tab key="1">{{ $t("outward") }}</v-tab>
                      <v-tabs-items v-model="tab_tecnical" class="mb-3">
                        <v-tab-item key="normal" class="pt-3">
                          <v-card class="pa-2">
                            <v-row>
                              <v-col>
                                <v-text-field
                                  v-model="formValues.air_permeability"
                                  :label="$t('air_permeability')"
                                  outlined
                                  v-validate="''"
                                  data-vv-name="air_permeability"
                                  :error-messages="
                                    errors.collect('air_permeability')
                                  "
                                ></v-text-field>
                              </v-col>
                              <v-col>
                                <v-text-field
                                  v-model="formValues.operating_force"
                                  :label="$t('operating_force')"
                                  outlined
                                  v-validate="''"
                                  data-vv-name="operating_force"
                                  :error-messages="
                                    errors.collect('operating_force')
                                  "
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-text-field
                                  v-model="formValues.driving_rain"
                                  :label="$t('driving_rain')"
                                  outlined
                                  v-validate="''"
                                  data-vv-name="driving_rain"
                                  :error-messages="
                                    errors.collect('driving_rain')
                                  "
                                ></v-text-field>
                              </v-col>
                              <v-col>
                                <v-text-field
                                  v-model="formValues.wind_load"
                                  :label="$t('wind_load')"
                                  outlined
                                  v-validate="''"
                                  data-vv-name="wind_load"
                                  :error-messages="errors.collect('wind_load')"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-text-field
                                  v-model="formValues.bulgary_resistence"
                                  :label="$t('bulgary_resistence')"
                                  outlined
                                  v-validate="''"
                                  data-vv-name="bulgary_resistence"
                                  :error-messages="
                                    errors.collect('bulgary_resistence')
                                  "
                                ></v-text-field>
                              </v-col>
                              <v-col>
                                <v-text-field
                                  v-model="formValues.rw_value"
                                  :label="$t('rw_value')"
                                  outlined
                                  v-validate=""
                                  data-vv-name="rw_value"
                                  :error-messages="errors.collect('rw_value')"
                                  :hint="$t('rw_value_hint')"
                                  persistent-hint
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-select
                                  v-model="formValues.fire_behaviour"
                                  :items="fire_categories"
                                  :label="$t('fire_behaviour') + ' *'"
                                  outlined
                                  required
                                  v-validate="'required'"
                                  data-vv-name="fire_behaviour"
                                  :error-messages="
                                    errors.collect('fire_behaviour')
                                  "
                                ></v-select>
                              </v-col>
                              <v-col>
                                <v-text-field
                                  v-model="formValues.dangerous_substances"
                                  :label="$t('dangerous_substances')"
                                  outlined
                                  v-validate=""
                                  data-vv-name="dangerous_substances"
                                  :error-messages="
                                    errors.collect('dangerous_substances')
                                  "
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-text-field
                                  v-model="formValues.shock_resistance"
                                  :label="$t('shock_resistance')"
                                  outlined
                                  v-validate="''"
                                  data-vv-name="shock_resistance"
                                  :error-messages="
                                    errors.collect('shock_resistance')
                                  "
                                ></v-text-field>
                              </v-col>
                              <v-col>
                                <v-text-field
                                  v-model="formValues.security_bearing"
                                  :label="$t('security_bearing')"
                                  outlined
                                  v-validate=""
                                  data-vv-name="security_bearing"
                                  :error-messages="
                                    errors.collect('security_bearing')
                                  "
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-text-field
                                  v-model="formValues.release_ability"
                                  :label="$t('release_ability')"
                                  outlined
                                  v-validate="''"
                                  data-vv-name="release_ability"
                                  :error-messages="
                                    errors.collect('release_ability')
                                  "
                                ></v-text-field>
                              </v-col>
                              <v-col>
                                <v-text-field
                                  v-model="formValues.mechanical_strength"
                                  :label="$t('mechanical_strength')"
                                  outlined
                                  v-validate=""
                                  data-vv-name="mechanical_strength"
                                  :error-messages="
                                    errors.collect('mechanical_strength')
                                  "
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-text-field
                                  v-model="formValues.duration_functional_test"
                                  :label="$t('duration_functional_test')"
                                  outlined
                                  v-validate="''"
                                  data-vv-name="duration_functional_test"
                                  :error-messages="
                                    errors.collect('duration_functional_test')
                                  "
                                ></v-text-field>
                              </v-col>
                              <v-col>
                                <v-text-field
                                  v-model="
                                    formValues.differential_climate_behaviour
                                  "
                                  :label="$t('differential_climate_behaviour')"
                                  outlined
                                  v-validate=""
                                  data-vv-name="differential_climate_behaviour"
                                  :error-messages="
                                    errors.collect(
                                      'differential_climate_behaviour'
                                    )
                                  "
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-text-field
                                  v-model="formValues.smoke_protection"
                                  :label="$t('smoke_protection')"
                                  outlined
                                  v-validate="''"
                                  data-vv-name="smoke_protection"
                                  :error-messages="
                                    errors.collect('smoke_protection')
                                  "
                                ></v-text-field>
                              </v-col>
                              <v-col>
                                <v-text-field
                                  v-model="formValues.production_classification"
                                  :label="$t('production_classification')"
                                  outlined
                                  v-validate="''"
                                  data-vv-name="production_classification"
                                  :error-messages="
                                    errors.collect('production_classification')
                                  "
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item key="outward" class="pt-3">
                          <v-card class="pa-2">
                            <v-row>
                              <v-col>
                                <v-text-field
                                  v-model="
                                    formValues.opening_outward_driving_rain
                                  "
                                  :label="$t('opening_outward_driving_rain')"
                                  outlined
                                  v-validate="''"
                                  data-vv-name="opening_outward_driving_rain"
                                  :error-messages="
                                    errors.collect(
                                      'opening_outward_driving_rain'
                                    )
                                  "
                                ></v-text-field>
                              </v-col>
                              <v-col>
                                <v-text-field
                                  v-model="formValues.opening_outward_wind_load"
                                  :label="$t('opening_outward_wind_load')"
                                  outlined
                                  v-validate="''"
                                  data-vv-name="opening_outward_wind_load"
                                  :error-messages="
                                    errors.collect('opening_outward_wind_load')
                                  "
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-text-field
                                  v-model="
                                    formValues.opening_outward_air_permeability
                                  "
                                  :label="
                                    $t('opening_outward_air_permeability')
                                  "
                                  outlined
                                  v-validate="''"
                                  data-vv-name="opening_outward_air_permeability"
                                  :error-messages="
                                    errors.collect(
                                      'opening_outward_air_permeability'
                                    )
                                  "
                                ></v-text-field>
                              </v-col>
                              <v-col> </v-col>
                            </v-row>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-tabs>
                    <v-row>
                      <v-col>
                        <v-select
                          v-model="formValues.rule_group_id"
                          :items="rulegroups"
                          :label="$t('rules')"
                          item-text="name"
                          item-value="id"
                          clearable
                          outlined
                          v-validate=""
                          data-vv-name="rule_group_id"
                          :error-messages="errors.collect('rule_group_id')"
                        ></v-select>
                      </v-col>
                      <v-col>
                        <v-select
                          v-model="formValues.flush"
                          :items="flush_values"
                          :label="$t('flush')"
                          outlined
                          v-validate=""
                          data-vv-name="flush"
                          :error-messages="errors.collect('flush')"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-select
                          v-model="formValues.ud_table_id"
                          :items="udtables"
                          :label="$t('ud_table')"
                          item-text="name"
                          item-value="id"
                          clearable
                          outlined
                          v-validate=""
                          data-vv-name="ud_table_id"
                          :error-messages="errors.collect('ud_table_id')"
                        ></v-select>
                      </v-col>
                      <v-col>
                        <v-text-field
                          v-model="formValues.ud_value"
                          :label="$t('ud_value')"
                          outlined
                          v-validate=""
                          type="number"
                          data-vv-name="ud_value"
                          :error-messages="errors.collect('ud_value')"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card color="#ddd" class="pa-2">
                    <v-data-table
                      :headers="itemHeaders"
                      :items="formValues.door_type_item_groups"
                      :loading="loading"
                      :multi-sort="true"
                      class="mt-3"
                      hide-default-footer
                      disable-pagination
                      :footer-props="{
                        'items-per-page-options': [10, 15, 50, -1]
                      }"
                    >
                      <template v-slot:top>
                        <v-toolbar flat color="white">
                          <h4 class="pt-5 pb-0">{{ $t("Items") }}</h4>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="red lighten-2"
                            dark
                            @click="item_dialog = true"
                          >
                            {{ $t("Add item") }}
                          </v-btn>
                        </v-toolbar>
                      </template>
                      <template v-slot:body>
                        <draggable
                          :list="formValues.door_type_item_groups"
                          tag="tbody"
                        >
                          <tr
                            v-for="(item,
                            index) in formValues.door_type_item_groups"
                            :key="index"
                          >
                            <td>
                              <v-icon small class="page__grab-icon">
                                mdi-arrow-all
                              </v-icon>
                            </td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.name_it }}</td>
                            <td>
                              <v-chip
                                v-for="subitem in item.items"
                                :key="subitem.id"
                                class="mb-2 mr-2"
                                >{{ subitem.code }}-{{ subitem.name }}</v-chip
                              >
                            </td>
                            <td>
                              <v-checkbox
                                readonly
                                v-model="item.display_specification"
                              ></v-checkbox>
                            </td>
                            <td>
                              <v-checkbox
                                readonly
                                v-model="item.required"
                              ></v-checkbox>
                            </td>
                            <td>
                              <span
                                :title="
                                  item.id == null ? $t('Save before edit') : ''
                                "
                              >
                                <v-icon
                                  small
                                  color="red"
                                  class="mr-2"
                                  @click="editValue(item)"
                                  :disabled="item.id == null"
                                >
                                  mdi-pencil
                                </v-icon></span
                              >
                            </td>
                            <td>
                              <v-icon
                                small
                                color="red"
                                class="mr-2"
                                @click="removeValue(item)"
                              >
                                mdi-minus-circle-outline
                              </v-icon>
                            </td>
                          </tr>
                        </draggable>
                      </template>
                    </v-data-table>
                    <v-dialog v-model="item_dialog" eager>
                      <v-container id="item-forms" fluid tag="section">
                        <base-material-card
                          color="primary"
                          icon="mdi-layers"
                          :title="
                            door_type_item_group.id
                              ? $t('Edit item')
                              : $t('Add item')
                          "
                          class="px-5 py-3"
                        >
                          <v-form
                            ref="item_dialog_form"
                            autocomplete="new-password"
                            lazy-validation
                            data-vv-scope="item_dialog_form"
                            @submit.prevent="addValue"
                          >
                            <v-row>
                              <v-col>
                                <v-text-field
                                  v-model="door_type_item_group.name"
                                  :label="$t('name')"
                                  data-vv-name="name"
                                  v-validate="'required'"
                                  outlined
                                  :error-messages="
                                    errors.collect('item_dialog_form.name')
                                  "
                                ></v-text-field>
                              </v-col>
                              <v-col>
                                <v-text-field
                                  v-model="door_type_item_group.name_it"
                                  :label="$t('name_it')"
                                  data-vv-name="name_it"
                                  outlined
                                  v-validate="'required'"
                                  :error-messages="
                                    errors.collect('item_dialog_form.name_it')
                                  "
                                ></v-text-field>
                              </v-col>
                            </v-row>
                            <v-autocomplete
                              v-model="door_type_item_group.items"
                              multiple
                              return-object
                              :filter="customFilter"
                              :items="items"
                              item-text="name"
                              item-value="item_id"
                              :label="$t('items')"
                              data-vv-name="items"
                              outlined
                              v-validate="'required'"
                              :error-messages="
                                errors.collect('item_dialog_form.items')
                              "
                            >
                              <template v-slot:selection="data">
                                <draggable
                                  :id="data.index"
                                  :list="door_type_item_group.items"
                                  v-bind="dragOptions"
                                  :move="move"
                                  @change="
                                    change(door_type_item_group.items, $event)
                                  "
                                >
                                  <v-chip
                                    draggable
                                    v-bind="data.attrs"
                                    :input-value="data.selected"
                                    :key="data.id"
                                    close
                                    @click:close="removeItemValue(data.item)"
                                    @mousedown.stop
                                    @click.stop
                                  >
                                    {{ data.item.code }}-{{ data.item.name }}
                                  </v-chip>
                                </draggable>
                              </template>
                              <template v-slot:item="data">
                                {{ data.item.code }}-{{ data.item.name }}
                              </template>
                            </v-autocomplete>
                            <v-row>
                              <v-col>
                                <v-checkbox
                                  v-model="door_type_item_group.required"
                                  :label="$t('required')"
                                ></v-checkbox>
                              </v-col>
                              <v-col>
                                <v-checkbox
                                  v-model="
                                    door_type_item_group.display_specification
                                  "
                                  :label="$t('display_specification')"
                                ></v-checkbox>
                              </v-col>
                            </v-row>

                            <v-card-actions class="pl-0">
                              <v-btn
                                color="primary"
                                class="mr-4"
                                @click="item_dialog = false"
                              >
                                {{ $t("back") }}
                              </v-btn>
                              <v-spacer></v-spacer>
                              <v-btn
                                color="primary"
                                class="mr-4"
                                @click="addValue"
                              >
                                {{ $t("save") }}
                              </v-btn>
                            </v-card-actions>
                          </v-form>
                        </base-material-card>
                      </v-container>
                    </v-dialog>
                  </v-card>
                  <v-card color="#ddd" class="pa-2">
                    <v-data-table
                      :headers="headers"
                      :items="formValues.components"
                      :loading="loading"
                      :multi-sort="true"
                      class="mt-3"
                      hide-default-footer
                      :footer-props="{
                        'items-per-page-options': [10, 15, 50, -1]
                      }"
                    >
                      <template v-slot:item.edit="{ item }">
                        <v-icon
                          small
                          color="red"
                          class="mr-2"
                          @click="editComponent(item)"
                        >
                          mdi-pencil
                        </v-icon>
                      </template>
                      <template v-slot:item.delete="{ item }">
                        <v-icon
                          small
                          color="red"
                          class="mr-2"
                          @click="deleteComponent(item)"
                        >
                          mdi-minus-circle-outline
                        </v-icon>
                      </template>
                      <template v-slot:top>
                        <v-toolbar flat color="white">
                          <h4 class="pt-5 pb-0">{{ $t("components") }}</h4>

                          <v-spacer></v-spacer>
                          <v-btn
                            color="red lighten-2"
                            dark
                            @click="createComponent"
                          >
                            {{ $t("Add Component") }}
                          </v-btn>
                          <v-dialog v-model="dialog" eager>
                            <componentform
                              :saveCallback="saveComponent"
                              :closeCallback="closeComponent"
                              v-model="component"
                            ></componentform>
                          </v-dialog>
                        </v-toolbar>
                      </template>
                    </v-data-table>
                  </v-card>
                  <v-card color="#ddd" class="pa-2">
                    <h4>{{ $t("certificates") }}</h4>
                    <documentUpload
                      :files="formValues.documents"
                      :uploadCallback="documentUploadCallback"
                      type="certificates"
                      :removeCallback="documentRemoveCallback"
                      :sortCallback="documentSortCallback"
                    ></documentUpload>
                    <h4>{{ $t("certificates_abroad") }}</h4>
                    <documentUpload
                      :files="formValues.documents"
                      :uploadCallback="documentUploadCallback"
                      type="certificates_abroad"
                      :removeCallback="documentRemoveCallback"
                      :sortCallback="documentSortCallback"
                    ></documentUpload>
                    <h4>{{ $t("manual_it") }}</h4>
                    <documentUpload
                      :files="formValues.documents"
                      :uploadCallback="documentUploadCallback"
                      type="manual_it"
                      :removeCallback="documentRemoveCallback"
                      :sortCallback="documentSortCallback"
                    ></documentUpload>
                    <h4>{{ $t("manual") }}</h4>
                    <documentUpload
                      :files="formValues.documents"
                      :uploadCallback="documentUploadCallback"
                      type="manual"
                      :removeCallback="documentRemoveCallback"
                      :sortCallback="documentSortCallback"
                    ></documentUpload>
                    <h4>{{ $t("documents") }}</h4>
                    <documentUpload
                      :files="formValues.documents"
                      :uploadCallback="documentUploadCallback"
                      type="documents"
                      :removeCallback="documentRemoveCallback"
                      :sortCallback="documentSortCallback"
                    ></documentUpload>
                    <h4>{{ $t("documents_abroad") }}</h4>
                    <documentUpload
                      :files="formValues.documents"
                      :uploadCallback="documentUploadCallback"
                      type="documents_abroad"
                      :removeCallback="documentRemoveCallback"
                      :sortCallback="documentSortCallback"
                    ></documentUpload>
                    <h4>{{ $t("drawings") }}</h4>
                    <documentUpload
                      :files="formValues.documents"
                      :uploadCallback="documentUploadCallback"
                      type="drawings"
                      :removeCallback="documentRemoveCallback"
                      :sortCallback="documentSortCallback"
                    ></documentUpload>

                    <h4>{{ $t("sketches") }}</h4>
                    <documentUpload
                      :files="formValues.documents"
                      :uploadCallback="documentUploadCallback"
                      type="sketches"
                      :removeCallback="documentRemoveCallback"
                      :sortCallback="documentSortCallback"
                    ></documentUpload>
                    <h4>{{ $t("images") }}</h4>
                    <documentUpload
                      :files="formValues.documents"
                      :uploadCallback="documentUploadCallback"
                      type="images"
                      :removeCallback="documentRemoveCallback"
                      :sortCallback="documentSortCallback"
                    ></documentUpload>
                    <h4>{{ $t("icons") }}</h4>
                    <documentUpload
                      :files="formValues.documents"
                      :uploadCallback="documentUploadCallback"
                      type="icons"
                      :removeCallback="documentRemoveCallback"
                      :sortCallback="documentSortCallback"
                    ></documentUpload>
                  </v-card>
                  <hr />
                  <h4 class="mt-3 mb-3">{{ $t("Ausschreibungstexte") }}</h4>
                  <v-tabs
                    v-model="tab_description"
                    background-color="gray"
                    dark
                  >
                    <v-tab key="de">{{ $t("DE") }}</v-tab>
                    <v-tab key="it">{{ $t("IT") }}</v-tab>
                    <v-tabs-items v-model="tab_description">
                      <v-tab-item key="de" class="pt-3">
                        <vue-editor
                          v-model="formValues.specification_text_de"
                          :editor-toolbar="customToolbar"
                        />
                      </v-tab-item>
                      <v-tab-item key="it" class="pt-3">
                        <vue-editor
                          v-model="formValues.specification_text_it"
                          :editor-toolbar="customToolbar"
                        />
                      </v-tab-item>
                    </v-tabs-items>
                  </v-tabs>

                  <v-card-actions class="pl-0">
                    <v-btn
                      color="primary"
                      class="mr-4"
                      @click="$router.push({ name: 'doorType.index' })"
                    >
                      {{ $t("back") }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      class="mr-4"
                      @click="saveItem(formValues.id ? true : false)"
                    >
                      {{ $t("save") }}
                    </v-btn>
                  </v-card-actions>
                </v-tab-item>
                <v-tab-item key="usage">
                  <v-spacer> </v-spacer>

                  <v-card color="#ddd" class="pa-2">
                    <h3>
                      {{ $t("Doortype usage") }}:<br />
                      {{ formValues.code }} - "{{ formValues.name }}"
                    </h3>
                    <v-card-text>
                      <p>
                        {{ $t("Total number of usage in orders") }}:
                        {{ Object.keys(orders).length }}
                      </p>
                      <v-list v-if="this.orders">
                        <v-list-item
                          :href="'/order/' + order[0].id"
                          v-for="(order, index) in this.orders"
                          :key="index"
                        >
                          {{ order.length }}
                          {{ $t("positions") }} | {{ order[0].project }} ({{
                            order[0].project_address
                          }})
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  saveItem,
  fetchItem,
  fetchTypeCategories,
  fetchFrames,
  fetchNumberRanges,
  fetchWallConnections,
  fetchUdTables,
  fetchRuleGroups,
  fetchArticleItems,
  deleteComponent,
  fetchTags,
  fetchEdgeSpacers,
  fetchCountries
} from "../shared/services";
import componentform from "./componentform";
import draggable from "vuedraggable";

import documentUpload from "../../shared/components/documents/document_upload";

export default {
  name: "app-doorType-item",
  components: {
    componentform,
    documentUpload,
    draggable
  },
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      tab: 0,
      tab_tecnical: 0,
      tab_description: 0,
      customToolbar: [
        [{ header: [false, 1, 2] }],
        ["bold", "italic", "underline"]
      ],
      formValues: {
        door_type_items: [],
        components: [],
        door_type_item_groups: [],
        orders: [],
        documents: [],
        door_type_category_id: null,
        production_notification: false
      },
      loading: true,
      typeCategories: [],
      label_types: [],
      frames: [],
      numberranges: [],
      wallconnections: [],
      edgespacers: [],
      udtables: [],
      rulegroups: [],
      glasses: [],
      items: [],
      countries: [],
      item_dialog: false,
      door_type_item_group: {
        id: null,
        name: "",
        name_it: "",
        items: [],
        required: false,
        display_specification: true
      },
      headers: [
        { text: "Typ", value: "type" },
        { text: "Beschreibung", value: "description" },
        { value: "edit" },
        { value: "delete" }
      ],
      fire_categories: [
        { value: "ei30", text: "EI 30" },
        { value: "ei60", text: "EI 60" },
        { value: "ei90", text: "EI 90" },
        { value: "npd", text: "npd" }
      ],
      flush_values: [
        { value: null, text: "Nein" },
        { value: "1", text: "Bandseitig" },
        { value: "2", text: "Beidseitig" }
      ],
      dialog: false,
      component: {
        door_type_id: this.$route.params.id
      },
      tags: [],
      dragOptions: {
        animation: 200,
        group: "group",
        disabled: false,
        ghostClass: "ghost",
        sort: true
      },
      dragged: {
        from: -1,
        to: -1,
        newIndex: -1
      }
    };
  },
  mounted() {
    fetchTypeCategories().then(res => {
      this.typeCategories = res.data;
    });
    fetchFrames().then(res => {
      this.frames = res.data;
    });
    fetchNumberRanges().then(res => {
      this.numberranges = res.data;
    });
    fetchWallConnections().then(res => {
      this.wallconnections = res.data;
    });
    fetchEdgeSpacers().then(res => {
      this.edgespacers = res.data;
    });
    fetchCountries().then(res => {
      this.countries = res.data;
    });
    fetchUdTables().then(res => {
      this.udtables = res.data;
    });
    fetchRuleGroups().then(res => {
      this.rulegroups = res.data;
    });
    fetchArticleItems({ page: 1, itemsPerPage: "-1" }).then(res => {
      this.items = res.data.map(item => {
        return {
          ...item,
          item_id: item.id,
          id: null
        };
      });
      this.glasses = res.data.filter(item => item.type == "glass");
    });
    fetchTags().then(res => {
      this.tags = res.data;
    });

    if (this.$route.params.id) {
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        //this.formatDoorTypesResponse(res.data);

        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    },
    orders() {
      return _.groupBy(this.formValues.orders, "id");
    },
    hasedgespacers() {
      let category = this.typeCategories.find(cat => {
        return cat.id == this.formValues.door_type_category_id;
      });

      if (category) {
        return !!category.has_edge_spacers;
      } else {
        return false;
      }
    },
    itemHeaders() {
      return [
        { sortable: false },
        { text: this.$t("name"), sortable: false },
        { text: this.$t("name_it"), sortable: false },
        { text: this.$t("items"), sortable: false },
        { text: this.$t("display_specification"), sortable: false },
        { text: this.$t("required"), sortable: false },
        { sortable: false },
        { sortable: false }
      ];
    }
  },
  methods: {
    async addValue() {
      // if (this.door_type_item_group.id) {
      //   this.formValues.door_type_item_groups = this.formValues.door_type_item_groups.filter(
      //     door_type_item_group => door_type_item_group.id != this.door_type_item_group.id
      //   );
      // }
      this.$validator.validateAll("item_dialog_form").then(res => {
        if (res) {
          if (!this.door_type_item_group.id) {
            this.formValues.door_type_item_groups.push({
              ...this.door_type_item_group,
              items: this.door_type_item_group.items.map(item => {
                return {
                  item_id: item.item_id,
                  name: item.name
                };
              })
            });
          }
          this.item_dialog = false;
          this.initDoorTypeItem();
        }
      });
    },
    initDoorTypeItem() {
      this.door_type_item_group = {
        name: "",
        name_it: "",
        items: [],
        required: false,
        display_specification: true
      };
    },
    editValue(item) {
      this.door_type_item_group = item;
      this.item_dialog = true;
    },
    async removeValue(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this itemgroup?")
        )
      ) {
        this.formValues.door_type_item_groups = this.formValues.door_type_item_groups.filter(
          door_type_item_group => door_type_item_group != item
        );
      }
    },
    removeItemValue(currentItem) {
      this.door_type_item_group.items = this.door_type_item_group.items.filter(
        item => item.item_id != currentItem.item_id
      );
    },
    formatDoorTypesResponse(data) {
      var door_type_items = [];
      data.door_type_items.map(door_type_item => {
        let obj = door_type_items.find(
          i => i.name == door_type_item.pivot.name
        );
        if (obj) {
          obj.items.push(door_type_item);
        } else {
          obj = {
            name: door_type_item.pivot.name,
            name_it: door_type_item.pivot.name_it,
            required: door_type_item.pivot.required,
            display_specification: door_type_item.pivot.display_specification,
            items: []
          };
          obj.items.push(door_type_item);
          door_type_items.push(obj);
        }
      });
      this.formValues.door_type_items = door_type_items;
    },
    createComponent() {
      this.saveItem(true).then(() => {
        this.dialog = true;
      });
    },
    closeComponent() {
      this.dialog = false;
      this.component = {
        door_type_id: this.$route.params.id
      };
    },
    async deleteComponent(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Component?")
        )
      ) {
        let resp = await deleteComponent(item.id);
        if (resp.success) {
          fetchItem(this.$route.params.id).then(res => {
            this.formValues = res.data;
            // this.formatDoorTypesResponse(res.data);
          });
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
      }
    },
    saveComponent() {
      this.component = {
        door_type_id: this.$route.params.id
      };
      this.dialog = false;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        // this.formatDoorTypesResponse(res.data);
      });
    },
    editComponent(item) {
      this.component = item;
      this.dialog = true;
    },
    removeTag(item) {
      this.formValues.tags.splice(this.formValues.tags.indexOf(item), 1);
      this.formValues.tags = [...this.formValues.tags];
    },
    documentUploadCallback(document) {
      this.formValues.documents.push(document);
    },
    documentRemoveCallback(document) {
      this.formValues.documents = this.formValues.documents.filter(
        _document => {
          if (_document.id == document.id) {
            if (_document.type == document.type) {
              return false;
            }
          }
          return true;
        }
      );
    },
    documentSortCallback(documents) {
      documents.map(doc => {
        this.formValues.documents = this.formValues.documents.filter(
          _document => _document.id != doc.id
        );
      });
      this.formValues.documents = [...this.formValues.documents, ...documents];
    },
    removeItem(item) {},
    async saveItem(remain = false) {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        if (remain) {
          this.loading = true;
          fetchItem(this.$route.params.id).then(res => {
            this.formValues = res.data;
            //this.formatDoorTypesResponse(res.data);

            this.loading = false;
          });
          // if (!this.$route.params.id) {
          //   this.component = {
          //     door_type_id: this.$route.params.id
          //   };
          //   this.$router.push({
          //     name: "doorType.edit",
          //     params: { id: resp.id }
          //   });
          // }
        } else {
          this.$router.push({ name: "doorType.index" });
        }
      }
    },
    customFilter(item, queryText, itemText) {
      const textOne = item.name.toLowerCase();
      const textTwo = item.code.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    move(value) {
      this.dragged = {
        from: parseInt(value.from.id),
        to: parseInt(value.to.id),
        newIndex: value.draggedContext.futureIndex
      };
    },
    change(list, value) {
      if (value.removed) {
        list.splice(
          this.dragged.to + this.dragged.newIndex,
          0,
          list.splice(this.dragged.from, 1)[0]
        );
      }
    },
    remove(list, index) {
      list.splice(index, 1);
    }
  },
  watch: {
    item_dialog: {
      handler(val) {
        if (!val) this.initDoorTypeItem();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
